import axiosInstance from './axiosinstance';
import { API_ENDPOINTS } from './urls';
import { getGameDetails } from '../LocalStorageService';

export const aiGenerateQuiz = async (data) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      url: API_ENDPOINTS.AI_GENERATE_QUIZ,
      data,
    });
    return response; // Response is already `response.data` from the interceptor
  } catch (error) {
    // Rethrow error for higher-level handling
    throw error;
  }
};

export const aiCreateQuestionCreateGame = async (
  data: CreateQuizGameRequest
) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      url: API_ENDPOINTS.AI_CREATE_QUESTION_GAME,
      data,
    });
    return response; // Response is already `response.data` from the interceptor
  } catch (error) {
    // Rethrow error for higher-level handling
    throw error;
  }
};
export const generateGeoPlay = async (data: GeoPlayCreateRequest) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      data,
      url: API_ENDPOINTS.GEO_CREATE_GAME,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const fetchPreviewNextPlayRound = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      method: 'GET',
      url: `${API_ENDPOINTS.NEXT_GEO_PLAY_ROUND}/${gameId}`,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const fetchCurrentGeoRoundResult = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      method: 'GET',
      url: `${API_ENDPOINTS.CURRENT_GEO_ROUND_RESULT}/${gameId}`,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const fetchPreviewLeaderboard = async (data: fetchRequest) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      data,
      url: API_ENDPOINTS.PREVIEW_LEADERBOARD,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const fetchPreviewPlayers = async (data: fetchRequest) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      data,
      url: API_ENDPOINTS.PREVIEW_PLAYERS,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchMyGames = async (data: fetchGamesRequest) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      data,
      url: API_ENDPOINTS.SUBSCRIBER_GAME_LIST,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createSubscription = async (data: subscriptionRequest) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      data,
      url: API_ENDPOINTS.CREATE_SUBSCRIPTION,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const fetchGameDetails = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      method: 'GET',
      url: `${API_ENDPOINTS.GAME_DETAILS}/${gameId}`,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchCategories = async () => {
  try {
    const response = await axiosInstance({
      method: 'GET',
      url: API_ENDPOINTS.BUSINSESS_CATEGORIES,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const fetchPlayersSummaries = async (data: {
  gameId: string;
  gameOwnerId: string;
}) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      data,
      url: API_ENDPOINTS.FETCH_PLAYER_SUMMARY,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchInvitedPlayers = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      method: 'GET',
      url: `${API_ENDPOINTS.FETCH_INVITEES}/${gameId}`,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const sendInvite = async (data: {
  gameId: string;
  emails: string[];
  gameOwnerId: string;
}) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      data,
      url: API_ENDPOINTS.SEND_INVITE_TO_PLAYERS,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchQuizPreview = async (gameId: string, page: number) => {
  try {
    const response = await axiosInstance({
      method: 'GET',
      url: `${API_ENDPOINTS.FETCH_QUIZ_PREVIEW}/${gameId}/${page}`,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
